import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

import {SessionService} from './../_shared/session/session.service';
import {BarraProgressoService} from './../_shared/barra-progresso/barra-progresso.service';
import {DocumentoGlobal} from './../_shared/documento/documento-global';
import {CandidatoService} from '../_shared/candidato/candidato.service';

@Component({
    selector: 'app-pergunta-documentos',
    templateUrl: './pergunta-documentos.component.html',
    styleUrls: ['./pergunta-documentos.component.css']
})
export class PerguntaDocumentosComponent implements OnInit {

    public inscricao_deferida = false;

    constructor(private router: Router,
                private candidato: CandidatoService,
                private SessionService: SessionService,
                private barraProgressoService: BarraProgressoService,
                public DocumentoGlobal: DocumentoGlobal) {
    }

    ngOnInit() {
        // if (this.DocumentoGlobal.inscricoes) {
        //     this.DocumentoGlobal.inscricoes.forEach(inscricao => {
        //         if (inscricao.inscricaoDeferida) {
        //             this.inscricao_deferida = inscricao.inscricaoDeferida;
        //         }
        //     });
        // }
        // console.log(this.DocumentoGlobal.inscricoes);

        if (this.DocumentoGlobal.inscricoes) {
            this.inscricao_deferida = this.DocumentoGlobal.inscricoes.some(inscricao => inscricao.inscricaoDeferida);
        }

        if (this.inscricao_deferida) {
            return this.barraProgressoService.atualizaProgresso(10);
        }

        const documentos = this.candidato.getDocumentosCandidato();

        if (documentos.length === 0) {
            return this.proximoFinal();
        }

        const documento = documentos[0];

        this.router.navigate(['documento', documento.TipDesURL]);
    }

    proximoFinal() {
        this.SessionService.setValor("final", "true");
		
        if (this.SessionService.getValor("matricula_redirecionar") === "true") {
			this.router.navigate(["/mensagem-final-matricula-online"]);
        } else {
			this.router.navigate(["/mensagem-final"]);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/pergunta-documentos/pergunta-documentos.component.ts